export default (function (pattern) {
  var escapeChars = '!#$%&*+-/=?^_`{|}~'.split('');
  return pattern.split('').reverse().reduce(function (acc, curr) {
    var _char = escapeChars.find(function (el) {
      return el === curr;
    }) ? '\\' + curr : curr;
    return _char + acc;
  }, '');
});